import { GenericPage } from "../components/common/GenericPage";
import {
  filmCollapseTableFields,
  filmTableFields,
} from "../utils/table-fields/filmTableFields";

export const AllFilms = () => {
  return (
    <GenericPage
      title="All Films"
      subtitle="Historical records of the cinematic episodes"
      parentQuery="allFilms"
      childQuery="films"
      tableFields={filmTableFields}
      collapseFields={filmCollapseTableFields}
    />
  );
};
